import { render, staticRenderFns } from "./ItemsToSale.vue?vue&type=template&id=9cbca980&scoped=true"
import script from "./ItemsToSale.vue?vue&type=script&lang=js"
export * from "./ItemsToSale.vue?vue&type=script&lang=js"
import style0 from "./ItemsToSale.vue?vue&type=style&index=0&id=9cbca980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbca980",
  null
  
)

export default component.exports